const state = {
    blogs: [],
    error: null,
    editBlog: false
};

export default state;
